/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ConstructionSiteState {
  $0 = 0,
  $1 = 1
}
